import { render, staticRenderFns } from "./AddNewSupplierAddressForm.vue?vue&type=template&id=f5ef3bf0&"
import script from "./AddNewSupplierAddressForm.vue?vue&type=script&lang=js&"
export * from "./AddNewSupplierAddressForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports